<ng-container *ngIf="!editing">
  <ng-content></ng-content>
</ng-container>

<form *ngIf="editing" [formGroup]="form" (ngSubmit)="save()" class="wo-panel-section wo-stop-editor">
  <div class="mb-5 flex items-center justify-between gap-3">
    <h3 class="m-0 text-base font-semibold">Edit {{ title | lowercase }}</h3>
    <button type="button" class="wo-panel-text-button" [disabled]="saving || busy" (click)="discard()">
      Cancel
    </button>
  </div>

  <fieldset class="m-0 min-w-0 border-0 p-0" [disabled]="saving || busy">
    <label class="wo-panel-label">
      <span>Search {{ title | lowercase }}</span>
      <input
        #companyInput
        class="wo-panel-input"
        [formControl]="search"
        [matAutocomplete]="companies"
        [readOnly]="loadingContact"
        autocomplete="off"
        placeholder="Search company name"
      />
    </label>
    <mat-autocomplete
      #companies="matAutocomplete"
      [displayWith]="displayCompany"
      (optionSelected)="chooseCompany($event.option.value)"
    >
      <mat-option *ngFor="let result of results" [value]="result">{{ result.label }}</mat-option>
    </mat-autocomplete>
    <p *ngIf="searching" class="m-0 mt-2 text-xs text-[var(--wo2-muted)]" role="status">Searching…</p>
    <p *ngIf="searchError" class="m-0 mt-2 text-sm text-rose-500" role="alert">{{ searchError }}</p>
    <p *ngIf="loadingContact" class="m-0 mt-3 text-sm text-[var(--wo2-muted)]" role="status">
      Loading addresses…
    </p>

    <div class="mt-4 space-y-4" [hidden]="loadingContact">
      <label class="wo-panel-label">
        <span>{{ title }} name on order</span>
        <input class="wo-panel-input" formControlName="name" autocomplete="off" />
      </label>
      <label class="wo-panel-label">
        <span>{{ title }} address</span>
        <select
          class="wo-panel-input"
          formControlName="contact_address_uuid"
          (change)="selectAddress(form.controls.contact_address_uuid.value)"
        >
          <option value="">New address</option>
          <option *ngFor="let address of addresses" [value]="address.contact_address_uuid">
            {{ addressLabel(address) }}
          </option>
        </select>
      </label>

      <label class="wo-panel-label">
        <span>{{ title }} street address</span>
        <input class="wo-panel-input" formControlName="address_street" autocomplete="off" />
      </label>
      <label class="wo-panel-label">
        <span>{{ title }} unit / suite</span>
        <input class="wo-panel-input" formControlName="address_extended" autocomplete="off" />
      </label>
      <div class="grid grid-cols-1 gap-4 min-[420px]:grid-cols-2">
        <label class="wo-panel-label">
          <span>{{ title }} city</span>
          <input class="wo-panel-input" formControlName="address_locality" autocomplete="off" />
        </label>
        <label class="wo-panel-label">
          <span>{{ title }} province / state</span>
          <input class="wo-panel-input" formControlName="address_region" autocomplete="off" />
        </label>
        <label class="wo-panel-label">
          <span>{{ title }} postal / ZIP code</span>
          <input class="wo-panel-input" formControlName="address_postal_code" autocomplete="off" />
        </label>
        <label class="wo-panel-label">
          <span>{{ title }} country</span>
          <input class="wo-panel-input" formControlName="address_country" autocomplete="off" />
        </label>
      </div>
      <label class="wo-panel-label">
        <span>{{ title }} timezone</span>
        <input
          class="wo-panel-input"
          formControlName="timezone_id"
          list="wo-panel-timezones"
          autocomplete="off"
        />
      </label>
      <label class="wo-panel-label">
        <span>{{ role === 'shipper' ? 'Pickup' : 'Delivery' }} hours</span>
        <input class="wo-panel-input" formControlName="hours" autocomplete="off" />
      </label>
      <p class="m-0 text-xs leading-5 text-[var(--wo2-muted)]">
        Address changes are saved as a separate location for this work order.
      </p>
    </div>

    <div *ngIf="error" class="wo-panel-notice mt-4" data-tone="error" role="alert">
      <div>
        <p class="m-0">{{ error }}</p>
        <button
          *ngIf="!companySelected"
          type="button"
          class="wo-panel-text-button mt-2"
          (click)="retryCompany()"
        >
          Retry loading company
        </button>
      </div>
    </div>
    <p
      *ngIf="hasChanges && !loadingContact && validationError"
      class="m-0 mt-4 text-sm text-rose-500"
      role="alert"
    >
      {{ validationError }}
    </p>
    <div class="mt-5 flex justify-end">
      <button type="submit" class="wo-panel-primary" [disabled]="!canSave">
        <i class="fa-solid" [ngClass]="saving ? 'fa-spinner fa-spin' : 'fa-check'" aria-hidden="true"></i>
        {{ saving ? 'Saving…' : 'Save ' + (title | lowercase) }}
      </button>
    </div>
  </fieldset>
</form>
